import UtilityServiceOrganizationPictures from '../API/common/UtilityServiceOrganizationPictures';
import {gatewayUrl} from '../Constants';

export const getSortedCompositionPictures = (item) => {
    const pictures = item?.pictures;
    if (!pictures?.length) {
        return [];
    }
    return [...pictures].sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
};

const resolvePictureUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return undefined;
    }
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
        return url;
    }
    if (url.startsWith('/')) {
        return `${gatewayUrl}${url}`;
    }
    return url;
};

const pickPictureUrl = (picture) => {
    if (!picture) {
        return undefined;
    }
    const raw =
        picture.relativeUrl
        || picture.relativeURL
        || picture.url
        || picture.fullUrl;
    return resolvePictureUrl(raw);
};

const pickThumbnailUrl = (picture) => {
    if (!picture) {
        return undefined;
    }
    const raw =
        picture.relativeUrlSmall
        || picture.relativeUrl
        || picture.relativeURL
        || picture.url;
    return resolvePictureUrl(raw);
};

export const compositionPictureNeedsUrlResolve = (picture) =>
    Boolean(picture?.id) && !pickPictureUrl(picture) && !pickThumbnailUrl(picture);

/**
 * GET /compositions/{id} часто отдаёт pictures без relativeUrl (только id/name/priority).
 * Полные URL — из /organizations/pictures/by-composition-media-id (как в настройках медиа).
 */
export async function fetchCompositionPicturesWithUrls(mediaId, pictures) {
    const list = Array.isArray(pictures) ? pictures : [];
    if (!mediaId) {
        return list;
    }
    const needsFetch = list.length === 0 || list.some(compositionPictureNeedsUrlResolve);
    if (!needsFetch) {
        return list;
    }
    try {
        const response = await UtilityServiceOrganizationPictures.getByCompositionMediaId(mediaId);
        const resolved = Array.isArray(response.data) ? response.data : [];
        if (list.length === 0) {
            return resolved;
        }
        const byId = new Map(resolved.map((picture) => [picture.id, picture]));
        return list.map((picture) => {
            const full = byId.get(picture.id);
            return full ? {...picture, ...full} : picture;
        });
    } catch {
        return list;
    }
}

export const getCompositionImageUrl = (item, picture) => {
    const fromPicture = pickPictureUrl(picture);
    if (fromPicture) {
        return fromPicture;
    }
    const fromItem = pickPictureUrl(item);
    if (fromItem) {
        return fromItem;
    }
    const pictures = getSortedCompositionPictures(item);
    return pickPictureUrl(pictures[0]);
};

export const getCompositionThumbnailUrl = (picture) => {
    return pickThumbnailUrl(picture);
};

/** relativeUrl / relativeUrlSmall из PictureDto → URL для `<img>` и превью. */
export const resolveOrganizationPictureUrl = resolvePictureUrl;
